import * as React from 'react';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from "@mui/material/Grid/Grid";
import {FormHelperText} from "@mui/material";

export default (data, key) => {
    return (
        <Grid item md={12} xs={12} key={key} className={data.classList}>
            <FormControl error={data.error ? true : false} key={key} component="fieldset" variant="standard">
                <FormLabel component="legend">{data.headerName}{data?.inputProps?.required ? '*' : ''}</FormLabel>
                <FormGroup>
                    {data.items.map((item, ind) => (
                        <FormControlLabel
                            control={
                                <Checkbox key={ind}
                                          checked={data.value.includes(item)}
                                          onChange={(e) => data.onCallback({target:{name:data.name, value: item}})}
                                          name={item}/>
                            }
                            label={item}
                        />
                    ))}
                </FormGroup>
                {data.error && (<FormHelperText>{data.error}</FormHelperText>)}
            </FormControl>
        </Grid>

    );
}